import {
  ExtractFnReturnType,
  QueryConfigType,
  useQuery,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesPostsReportsIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
  companyId: string;
};

const request = async ({
  page = 1,
  companyId,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesPostsReportsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesPostsReportsIndexResponseType>(
      `/api/admin_operators/companies/${companyId}/posts_reports`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
  companyId: string;
};

export const useApisAdminOperatorsCompaniesPostsReportsIndex = ({
  companyId,
  config = {},
}: PropsType): UseQueryResult<ApisAdminOperatorsCompaniesPostsReportsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesPostsReportsIndex", companyId],
    () => request({ companyId }),
    {
      ...config,
    },
  );
};
